import { Box, Container, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

import signUp from "../../../../assets/images/icons/signup.svg";
import editNote from "../../../../assets/images/icons/edit-note.svg";
import starRate from "../../../../assets/images/icons/star-rate.svg";
import supervisorAccount from "../../../../assets/images/icons/supervisor-account.svg";
import aboutBgImg from "../../../../assets/images/icons/about-bg.png";

const Methodology = () => {
  const { t } = useTranslation("about");
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  const steps = [
    {
      icon: signUp,
      text: (
        <>
          {t("methodology.steps.0.text")}{" "}
          <a
            href={import.meta.env.VITE_DYNAMIC_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {import.meta.env.VITE_DYNAMIC_URL}
          </a>{" "}
          {t("methodology.steps.0.text2")}
        </>
      ),
    },
    { icon: editNote, text: t("methodology.steps.1.text") },
    { icon: starRate, text: t("methodology.steps.2.text") },
    { icon: supervisorAccount, text: t("methodology.steps.3.text") },
  ];

  return (
    <Box
      component="section"
      aria-labelledby="steps-heading"
      sx={{
        py: { xs: 7, md: 9 },
        color: "text.primary",
        backgroundColor: isDarkMode ? "#202b2b" : "#e3fffb",
        backgroundImage: isDarkMode
          ? `linear-gradient(rgba(32, 43, 43, 0.95), rgba(32, 43, 43, 0.95)), url(${aboutBgImg})`
          : `linear-gradient(rgba(227, 255, 251, 0.88), rgba(227, 255, 251, 0.92)), url(${aboutBgImg})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <Container maxWidth="xl" sx={{ px: { xs: 2.5, md: 6, lg: 9 } }}>
        <Typography
          id="steps-heading"
          component="h2"
          sx={{
            mb: { xs: 4, md: 5 },
            color: isDarkMode ? "#f5f7f6" : "#0f202b",
            fontSize: {
              xs: `calc(28px * var(--dynamic-font-size, 1))`,
              md: `calc(40px * var(--dynamic-font-size, 1))`,
            },
            fontWeight: 700,
          }}
        >
          {t("methodology.title")}
        </Typography>

        <Box sx={{ display: "grid", gap: { xs: 3, md: 4 } }}>
          {steps.map((step, index) => (
            <Box
              key={index}
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "52px minmax(0, 1fr)", md: "64px minmax(0, 1fr)" },
                alignItems: "center",
                gap: { xs: 2, md: 3 },
              }}
            >
              <Box
                sx={{
                  width: { xs: 50, md: 58 },
                  height: { xs: 50, md: 58 },
                  display: "grid",
                  placeItems: "center",
                  borderRadius: "50%",
                  bgcolor: isDarkMode ? "rgba(184,184,184,.12)" : "rgba(26,95,32,.08)",
                  "& img": {
                    width: { xs: 27, md: 32 },
                    height: { xs: 27, md: 32 },
                    objectFit: "contain",
                    filter: isDarkMode
                      ? "brightness(0) saturate(100%) invert(72%)"
                      : "brightness(0) saturate(100%) invert(28%) sepia(18%) saturate(1953%) hue-rotate(76deg) brightness(91%) contrast(93%)",
                  },
                }}
              >
                <img src={step.icon} alt="" aria-hidden="true" />
              </Box>

              <Typography
                sx={{
                  color: isDarkMode ? "#d7ddda" : "#1b2921",
                  fontSize: {
                    xs: `calc(14px * var(--dynamic-font-size, 1))`,
                    md: `calc(17px * var(--dynamic-font-size, 1))`,
                  },
                  lineHeight: 1.65,
                  "& a": {
                    color: isDarkMode ? "#d0d0d0" : "#1A5F20",
                    fontWeight: 600,
                    textUnderlineOffset: "3px",
                  },
                }}
              >
                {step.text}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default Methodology;
